"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.codeErrorSelector = codeErrorSelector;
exports.hasCodeErrorSelector = hasCodeErrorSelector;
exports.isConfirmPhoneFormSubmittingSelector = isConfirmPhoneFormSubmittingSelector;
exports.sendSmsStatusSelector = sendSmsStatusSelector;
exports.viewDataEmailSelector = viewDataEmailSelector;
exports.viewDataPhoneSelector = viewDataPhoneSelector;
var _registration = require("../../../../types/registration");
function sendSmsStatusSelector(state) {
  return state.registration.sendSms.status;
}
function isConfirmPhoneFormSubmittingSelector(state) {
  return state.registration.confirmPhone.status === _registration.EConfirmPhoneStatus.Loading || state.registration.sendSms.status === _registration.ESendSmsStatus.Loading;
}
function hasCodeErrorSelector(state) {
  const {
    status,
    error
  } = state.registration.confirmPhone;
  const {
    status: smsStatus,
    error: smsError
  } = state.registration.sendSms;
  return status === _registration.EConfirmPhoneStatus.Failed && error !== undefined || smsStatus === _registration.ESendSmsStatus.Failed && smsError !== undefined;
}
function codeErrorSelector(state) {
  return hasCodeErrorSelector(state) ? state.registration.confirmPhone.error || state.registration.sendSms.error : undefined;
}
function viewDataPhoneSelector(state) {
  return state.view.data.phone;
}
function viewDataEmailSelector(state) {
  return state.view.data.email;
}